import React from 'react';
import type ExternalImportType from '@atlassian/jira-spa-apps-external-import/src/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const LazyExternalImport = lazyForPaint<typeof ExternalImportType>(
	() =>
		import(
			/* webpackChunkName: "async-system-external-import", jiraSpaEntry: "async-system-external-import" */ '@atlassian/jira-spa-apps-external-import'
		),
	{ ssr: false },
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage Page={LazyExternalImport} pageId="external-import-general" shouldShowSpinner={false} />
);
